import { Platform } from 'react-native';
import DeviceInfo from 'react-native-device-info';
import {
  NetInfoCellularGeneration,
  NetInfoState,
  NetInfoStateType,
} from '@react-native-community/netinfo';
import NetInfo from 'app/services/IsolatedNetInfo';

export const BATTERY_LOW_THRESHOLD = 0.1;
export const BATTERY_POLL_INTERVAL_MS = 60_000;
export const WIFI_WEAK_STRENGTH_THRESHOLD = 55;
export const WIFI_POLL_INTERVAL_MS = 30_000;
export const WIFI_WEAK_CONFIRM_MS = 20_000;
export const GATEWAY_POLL_INTERVAL_MS = 300_000;

export const extractWifiStrength = (state: NetInfoState): number | null => {
  if (Platform.OS !== 'android') return null;
  if (state.type !== NetInfoStateType.wifi) return null;

  const strength = state.details?.strength;
  return typeof strength === 'number' ? strength : null;
};

export const readBatteryLevel = (): Promise<number> => DeviceInfo.getBatteryLevel();

export const readWifiStrength = async (): Promise<number | null> => extractWifiStrength(await NetInfo.refresh());

export const POOR_CELLULAR_GENERATIONS: NetInfoCellularGeneration[] = [
  NetInfoCellularGeneration['2g'],
  NetInfoCellularGeneration['3g'],
];

export const isNetworkSignalPoor = (state: NetInfoState): boolean => {
  if (state.type === NetInfoStateType.wifi) {
    const strength = extractWifiStrength(state);
    return strength !== null && strength < WIFI_WEAK_STRENGTH_THRESHOLD;
  }

  if (state.type === NetInfoStateType.cellular) {
    const generation = state.details?.cellularGeneration;
    return !!generation && POOR_CELLULAR_GENERATIONS.includes(generation);
  }

  return false;
};
